import { ReactNode } from 'react';
import cx from 'classnames';

import { BackButton } from '../back-button';
import { Heading } from '../heading';

export interface PageHeaderProps {
  title: ReactNode;
  /** Where the back arrow leads; no arrow without it. */
  backTo?: string;
  className?: string;
}

/** The title row of an inner page: back arrow and the page's `h1`. */
export const PageHeader = ({ title, backTo, className }: PageHeaderProps) => (
  <div className={cx('mb-5 flex items-center gap-3.5', className)}>
    {backTo && <BackButton className="-m-1.5" to={backTo} />}
    <Heading size="xl" className="min-w-0">
      {title}
    </Heading>
  </div>
);
